import { createRef, useCallback, useEffect, useRef, useState } from "react";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { ReactCropperElement, Cropper } from "react-cropper";
import { Button, Container, FormLabel } from "@mui/material";
import Webcam from "react-webcam";
import { Controller } from "react-hook-form";

export const FCameraCapture: React.FC<FBasicPropos> = ({ field, control, errors, errorMessage }) => {
    const ImageCrop = ({
        imgSrc,
        setCropData,
    }: {
        imgSrc: string;
        setCropData: (arg0: string) => void;
    }) => {
        const [image, setImage] = useState(imgSrc);

        const cropperRef = createRef<ReactCropperElement>();

        useEffect(() => {
            setImage(imgSrc);
        }, [imgSrc]);

        const getCropData = () => {
            if (typeof cropperRef.current?.cropper !== "undefined") {
                setCropData(
                    cropperRef.current?.cropper.getCroppedCanvas().toDataURL()
                );
            }
        };

        return (
            <div className="space-x-4">
                <div className="space-y-2">
                    <Cropper
                        className="w-[360px] h-[360px]"
                        ref={cropperRef}
                        zoomTo={0.5}
                        initialAspectRatio={1}
                        // preview=".img-preview"
                        src={image}
                        viewMode={1}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                        guides={true}
                    />
                    <Button
                        className="align-middle"
                        onClick={getCropData}
                        variant="contained"
                    >
                        {" "}
                        Crop
                    </Button>
                </div>
            </div>
        );
    };

    const CropedImage = ({ cropData }: { cropData: string | null }) => {
        return (
            <div>
                {!!cropData && (
                    <div className="space-y-2">
                        <img
                            className="object-fill w-[360px] h-[360px]"
                            src={cropData}
                        />
                        <FormLabel>Customer Image</FormLabel>
                    </div>
                )}
            </div>
        );
    };

    const webcamRef = useRef<Webcam>(null);
    const [imgSrc, setImgSrc] = useState<string | null>(null);
    const [cropData, setCropData] = useState<string | null>(null);

    const captureCallback = useCallback(() => {
        const imageSrc = webcamRef.current?.getScreenshot();
        if (imageSrc) {
            setImgSrc(imageSrc);
        }
    }, [webcamRef]);

    const name = field.name;
    if (!errorMessage) errorMessage = errors[name]?.message as string;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue=""
            render={({ field: controllerField }) => {
                const capture = () => {
                    captureCallback();
                    controllerField.onChange(imgSrc);
                };
                return (
                    <Container className="border-2 rounded space-y-4 pt-4 pb-4">
                        <div className="flex flex-row space-x-4">
                            <div className="space-y-2">
                                <Webcam
                                    className="flex w-[360px] h-[360px]"
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/jpeg"
                                />
                                <Button onClick={capture} variant="contained">
                                    {" "}
                                    Capture photo
                                </Button>
                            </div>
                            <div className="w-[360px] h-[360px]">
                                {imgSrc && (
                                    <div>
                                        <ImageCrop
                                            imgSrc={imgSrc}
                                            setCropData={setCropData}
                                        ></ImageCrop>
                                    </div>
                                )}
                            </div>

                            <div className="w-[360px] h-[360px]">
                                <CropedImage cropData={cropData}></CropedImage>
                            </div>
                        </div>
                    </Container>
                );
            }}
        />
    );
};